import { useEffect, useState } from 'react';
import { BREAKPOINTS } from "../../constants";
import { BreakpointValue } from "../../types";
import useMediaQuery from '../useMediaQuery';
/**
 * The useBreakpoint hook which returns breakpoint.
 * @returns {number} - the breakpoint value (xsmall, small, medium, large and xlarge).
 */
const useBreakpoint = () => {
    const [breakpoint, setBreakpoint] = useState(BREAKPOINTS.xsmall);
    const isXSmallBreakpoint = useMediaQuery(BREAKPOINTS.xsmall);
    const isSmallBreakpoint = useMediaQuery(BREAKPOINTS.small);
    const isMediumBreakpoint = useMediaQuery(BREAKPOINTS.medium);
    const isLargeBreakpoint = useMediaQuery(BREAKPOINTS.large);
    const isXLargeBreakpoint = useMediaQuery(BREAKPOINTS.xlarge);
    useEffect(() => {
        if (isXSmallBreakpoint) {
            setBreakpoint(BREAKPOINTS.xsmall);
        }
        else if (isSmallBreakpoint) {
            setBreakpoint(BREAKPOINTS.small);
        }
        else if (isMediumBreakpoint) {
            setBreakpoint(BREAKPOINTS.medium);
        }
        else if (isLargeBreakpoint) {
            setBreakpoint(BREAKPOINTS.large);
        }
        else if (isXLargeBreakpoint) {
            setBreakpoint(BREAKPOINTS.xlarge);
        }
        else {
            setBreakpoint(BREAKPOINTS.xlarge);
        }
    }, [
        isXSmallBreakpoint,
        isSmallBreakpoint,
        isMediumBreakpoint,
        isLargeBreakpoint,
        isXLargeBreakpoint,
    ]);
    return breakpoint;
};
export default useBreakpoint;
//# sourceMappingURL=useBreakpoint.js.map